/** Check this link before editing https://material.angular.io/components/dialog/api */

// Angular
import { Component, Inject, Input, OnInit, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IConfirmDialogData } from "./confirm-dialog.interface";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'confirm-dialog',
    template: `
        <card [@.disabled]="true" mat-dialog-content>
            <div class="card-header-content">
                <h1>{{ data.title }}</h1>
                <div class="btn-container">
                    <btn *ngIf="data.seeMore && data.seeMoreAction" type="actionUndo" [label]="data.seeMore" (onClick)="closeWithAction(data.seeMoreAction)"></btn>
                    <btn type="actionLink" [label]="data.cancel" (onClick)="cancel()"></btn>
                    <btn class="e2e-btn-update"type="actionDo" [label]="data.accept" (onClick)="close()"></btn>
                </div>
            </div>

            <div class="card-body-content">
                <p *ngIf="!isLoading">{{ data.question }}</p>
                <loader *ngIf="isLoading" [message]="data.loaderMessage"></loader>
            </div>
        </card>
    `,
    styles: [`

        .card-body-content {
            padding: .75rem .75rem 0 .75rem;
        }
        .card-header-content{
            display: flex;
            justify-content: space-between;
        }

        .btn-container {
            display: flex;
        }`]
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
    public sanitizer: DomSanitizer;

    @Input()
    public isLoading: boolean = false;

    private readonly subscription: Subscription = new Subscription();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData,
        private readonly matDialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {}

    public ngOnInit(): void {
        this.subscription.add(
            this.matDialogRef.keydownEvents()
                .pipe(
                    filter((event: KeyboardEvent) => event.key === "Enter"),
                )
                .subscribe(() => {
                    this.close();
                })
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public cancel(action?: string): void {
        action ? this.matDialogRef.close(action) : this.matDialogRef.close();
    }

    public closeWithAction(action: string): void {
        this.matDialogRef.close(action);
    }

    public close(): void {
        this.matDialogRef.close('process');
    }
}